import { ModalWithTrash as TrashWithModal } from '@investoro/core';

export default TrashWithModal;
